export const positiveFloatValidationRegex =
  /^[+]?([0-9]+([.][0-9]*)?|[.][0-9]+)$/;
export const positiveIntegerValidationRegex = /^(0|[1-9][0-9]*)$/;
export const validEmailRegex =
  /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
export const validHealthCoachEmailRegex =
  /^[a-z|-]+(?:\.[a-z|-]+)?@euc\.coach$/;
export const noUppercaseRegex = /^[^A-Z]*$/;
